import React, { Component } from "react";
import axios from "axios";

let map = "";
let mapB = "";
let bounds = "";
let markers = [];

let resultsummary;
let resultList;
let searchButton;
let searchLocations;

const labels = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
let labelIndex = 0;
let csrftoken = "";
let localenv = false;
let searchTarget = "";
let city = "";
let province = "";
let country = "";
let postal_code = "";
let usersearchLocation = "";
let address = "";
let c_lat = "";
let c_lng = "";
let userAgree = "";
let targetZoom = "11";
let targetZoomB = "11";
let targetMap = "";
let targetMapB = "";
let resizing = false;
let userlang = "";

const googleMapsApiKey = "AIzaSyDhMR5djquStcUMteJd-HGsTmFMEfriXak";
const googleMapsApiKeyGeo = "AIzaSyD-1R__PLy_qjhacAvsv-hSXYaBMRsSEKk";

const shareLoc = window.document.getElementById("locationButton");

searchButton = window.document.getElementById("searchButton");
// searchButton.window.onclick = this.searchLocations();
// searchButton.setAttribute("onClick", "searchLocations()")

class Storelocator extends Component {
  componentDidMount() {
    this.renderMap();
    if (window.location.hostname !== "localhost") {
      csrftoken = window.document.getElementById("tracker-id").value;
    } else {
      localenv = true;
      const csrftokenB = window.document.getElementById("tracker-id").value;
      //console.log(csrftokenB)
    }
    if (window.location.pathname === "/en/find-a-retailer/") {
      userlang = "en";
    }

    //Document.getElementsById("default").addEventListener("load", this.initMap);
    //Document.getElementsById("default").addEventListener("load", this.getSizex);
    //Document.getElementsById("default").addEventListener("resize", this.getSizex);
    //google.maps.event.addDomListener(window, 'load', this.initMap);
    //google.maps.event.addDomListener(window, 'load', this.getSizex);
    //google.maps.event.addDomListener(window, 'resize', this.getSizex);
  }

  renderMap = () => {
    // loadScript(
    //   'https://maps.googleapis.com/maps/api/js?libraries=places&key=AIzaSyCdjG-mzPQYBHAaXbA_2KkVcg-AfmTPtJ4&callback=initMap'
    // );
    const googleApiScript = `https://maps.googleapis.com/maps/api/js?libraries=places&key=${googleMapsApiKey}&callback=initMap`;
    loadScript(googleApiScript);

    //window.getSizex = this.getSizex;
    window.geopos = this.geopos;
    window.userSearch = this.userSearch;
    window.searchLocations = this.searchLocations;
    window.searchLocationsNear = this.searchLocationsNear;
    window.targetStore = this.targetStore;
    window.initMap = this.initMap;
    targetMap = document.getElementById("map");
    targetMapB = document.getElementById("mapB");
    targetZoom = 11;
    targetZoomB = 7;
    //clnMap =    window.document.getElementById('geomap');
  };

  getSizex = () => {
    //console.log(`getting screen size ${map} ${mapB}`);
    //this.clearLocations();
    //window.document.getElementById('summary').style.visibility = 'hidden';
    const screenSize = window.document.documentElement.clientWidth;
    const XscreenSize = window.document.documentElement.screenSize;
    //window.google.maps.event.addDomListener(window, 'load', this.initMap);

    //console.log(`screensize: ${XscreenSize} screenwidth: ${screenSize}`);
    if (screenSize >= 1401) {
      //targetMap = window.document.getElementById('map');
      targetZoom = 11;
    } else if ((screenSize >= 480) & (screenSize <= 500)) {
      targetZoom = 4;
    } else if ((screenSize >= 500) & (screenSize <= 768)) {
      targetZoom = 5;
    } else if ((screenSize > 768) & (screenSize <= 1400)) {
      targetZoom = 9;
    } else {
      targetZoom = 7;
      //window.google.maps.event.addDomListener(window, 'load', this.initMap);
    }
  };

  showCurrentLocation = () => {
    // window.initMap = this.initMap;
    const options = {
      enableHighAccuracy: false,
      timeout: 5000,
      maximumAge: 0
    };
    // this.revokePermission()

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        function(position) {
          const geolocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };

          const startPos = position;
          window.document.getElementById("startLat").value =
            startPos.coords.latitude;
          document.getElementById("startLon").value = startPos.coords.longitude;
          const startLat = window.document.getElementById("startLat").value;
          const startLon = window.document.getElementById("startLon").value;
          /* var circle = new window.google.maps.Circle(
                    {center: geolocation, radius: position.coords.accuracy}); */
          window.initMap(parseFloat(startLat), parseFloat(startLon));
        },
        function(error) {
          // console.log('Error occurred. Error code: ' + error.code);
          // error.code can be:
          //   0: unknown error
          //   1: permission denied
          //   2: position unavailable (error response from location provider)
          //   3: timed out
          window.document.getElementById("locationButton").disabled = true;
          window.document.getElementById("startLat").value = "";
          window.document.getElementById("startLon").value = "";
        },
        options
      );
    }
  };

  initialize = () => {
    resultsummary = document.getElementById("summary");
    resultList = document.getElementById("locator-results");
    resultList.innerHTML = "";
    //window.google.maps.event.addDomListener(window, 'load', this.getSizex);
    //window.google.maps.event.addDomListener(window, 'load', this.initMap);
    window.google.maps.event.addDomListener(window, "resize", this.getSizex);
  };

  initAutocomplete = () => {
    // Create the autocomplete object, restricting the search predictions to
    // geographical location types.
    const autocomplete = new window.google.maps.places.Autocomplete(
      document.getElementById("addressInput"),
      { types: ["geocode"] }
    );
  };

  initMap = (center_lat = "", center_lon = "") => {
    //console.log('Inside init Map')

    if ((center_lat === "") & (center_lon === "")) {
      center_lat = 56.130367;
      center_lon = -106.346771;
    } else {
      userAgree = true;
    }

    const locale = {
      lat: parseFloat(center_lat),
      lng: parseFloat(center_lon)
    };

    //console.log('map: ' + targetMap.getAttribute('id'))
    //console.log('mapB: ' + targetMapB.getAttribute('id'))

    // Big Map
    map = new window.google.maps.Map(targetMap, {
      center: locale,
      zoom: 11,
      mapTypeId: "roadmap",
      mapTypeControl: false,
      mapTypeControlOptions: {
        style: window.google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
        position: window.google.maps.ControlPosition.TOP_LEFT
      },
      zoomControl: true,
      zoomControlOptions: {
        position: window.google.maps.ControlPosition.TOP_RIGHT
      },
      scaleControl: true,
      streetViewControl: false,
      streetViewControlOptions: {
        position: window.google.maps.ControlPosition.LEFT_TOP
      },
      fullscreenControl: true
    });

    //Mobile Map
    mapB = new window.google.maps.Map(targetMapB, {
      center: locale,
      zoom: 7,
      mapTypeId: "roadmap",
      mapTypeControl: false,
      mapTypeControlOptions: {
        style: window.google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
        position: window.google.maps.ControlPosition.TOP_LEFT
      },
      zoomControl: true,
      zoomControlOptions: {
        position: window.google.maps.ControlPosition.TOP_RIGHT
      },
      scaleControl: true,
      streetViewControl: false,
      streetViewControlOptions: {
        position: window.google.maps.ControlPosition.LEFT_TOP
      },
      fullscreenControl: false
    });

    window.onresize = function() {
      let currCenter = map.getCenter();
      window.google.maps.event.trigger(map, "resize");
      map.setCenter(currCenter);
      map.setZoom(targetZoom);
      let currCenterB = mapB.getCenter();
      window.google.maps.event.trigger(mapB, "resize");
      mapB.setCenter(currCenterB);
      mapB.setZoom(targetZoomB);
    };

    this.initialize();
    this.initAutocomplete();

    shareLoc.setAttribute("onClick", "geopos()");
    searchButton.setAttribute("onClick", "userSearch()");

    let params = new URL(document.location).searchParams;
    let addr = params.get("addr");
    if (addr !== "") document.getElementById("addressInput").value = addr;

    if (
      (document.getElementById("addressInput").value !== "") &
      (addr !== "")
    ) {
      // and button click searchButton

      this.searchLocations();
    }

    if (userAgree) {
      this.initNearUser(center_lat, center_lon);
    }
  };

  geopos = () => {
    window.document.getElementById("summary").innerHTML = "";
    window.document.getElementById("addressInput").value = "";
    window.history.pushState("", "", "?addr=");
    this.showCurrentLocation();
  };

  userSearch = e => {
    userAgree = false;
    window.document.getElementById("summary").innerHTML = "";
    this.searchLocations();
  };

  initNearUser = (center_lat, center_lon) => {
    this.clearLocations();
    labelIndex = 0;
    const radius = window.document.getElementById("radiusSelect").value;
    let psearchUrl = "/storefinder/";

    const params = {
      lat: center_lat,
      lng: center_lon,
      radius
    };

    if (localenv === true) {
      psearchUrl = "http://localhost:8000/localstores/";
      this.localdownloadUrl(psearchUrl, params);
    } else {
      this.downloadUrl(psearchUrl, params);
    }
  };

  buildMaps = (data, params) => {
    this.createMap(data, params);
    this.createMapB(data, params);
  };

  createMap = (data, params) => {
    let convert = require("xml-js");
    let markerNodes = "";

    bounds = new window.google.maps.LatLngBounds();
    if (data !== "") {
      //jsonData = convert.xml2json(data, {compact: false, spaces: 4});
      const parser = new DOMParser();
      const xml = parser.parseFromString(data, "text/xml");
      markerNodes = xml.documentElement.getElementsByTagName("marker");
    } else {
      markerNodes = "";
    }

    if (Object.keys(markerNodes).length === 0) {
      const center_lat = 56.130367;
      const center_lon = -106.346771;
      const searchfield = window.document.getElementById("addressInput").value;
      const radius = window.document.getElementById("radiusSelect").value;

      if (searchfield !== "") {
        window.history.pushState("", "", "?addr=" + searchfield);
        if (userlang === "en") {
          window.document.getElementById(
            "msg"
          ).innerHTML = `<p>There are no store locations (within ${radius} kms) near ${searchfield}. Please modify your search and try again.</p>`;
        } else {
          window.document.getElementById(
            "msg"
          ).innerHTML = `<p>Il n'y a pas de magasin (à moins de ${radius} km) près de ${searchfield}. Veuillez modifier votre recherche et réessayer.</p>`;
        }
      }

      const latlng = new window.google.maps.LatLng(
        parseFloat(center_lat),
        parseFloat(center_lon)
      );
    } else {
      const rcount = Object.keys(markerNodes).length;

      window.document.getElementById("msg").innerHTML = "";
      window.document.getElementById("locator-results-row").style.display =
        "block";

      this.getCityState(params.lat, params.lng, rcount);

      for (let i = 0; i < markerNodes.length; i++) {
        const storeId = markerNodes[i].getAttribute("storeId");
        const name = markerNodes[i].getAttribute("name");
        const address = markerNodes[i].getAttribute("address");
        const phone = markerNodes[i].getAttribute("phone");
        const postalCode = markerNodes[i].getAttribute("postalCode");
        const city = markerNodes[i].getAttribute("city");
        const province = markerNodes[i].getAttribute("province");

        const latlng = new window.google.maps.LatLng(
          parseFloat(markerNodes[i].getAttribute("lat")),
          parseFloat(markerNodes[i].getAttribute("lng"))
        );

        this.createMarker(
          latlng,
          name,
          address,
          city,
          province,
          postalCode,
          phone,
          storeId
        );
        bounds.extend(latlng);

        this.createResultsList(
          storeId,
          name,
          address,
          phone,
          city,
          province,
          postalCode
        );
      }

      map.fitBounds(bounds);
    }
  };

  createMapB = (data, params) => {
    let convert = require("xml-js");
    let markerNodesB = "";

    let boundsB = new window.google.maps.LatLngBounds();
    if (data !== "") {
      const parser = new DOMParser();
      const xml = parser.parseFromString(data, "text/xml");
      markerNodesB = xml.documentElement.getElementsByTagName("marker");
    } else {
      markerNodesB = "";
    }

    if (Object.keys(markerNodesB).length === 0) {
      const center_lat = 56.130367;
      const center_lon = -106.346771;

      const latlng = new window.google.maps.LatLng(
        parseFloat(center_lat),
        parseFloat(center_lon)
      );
    } else {
      for (let i = 0; i < markerNodesB.length; i++) {
        const storeId = markerNodesB[i].getAttribute("storeId");
        const name = markerNodesB[i].getAttribute("name");
        const address = markerNodesB[i].getAttribute("address");
        const phone = markerNodesB[i].getAttribute("phone");
        const postalCode = markerNodesB[i].getAttribute("postalCode");
        const city = markerNodesB[i].getAttribute("city");
        const province = markerNodesB[i].getAttribute("province");

        const latlng = new window.google.maps.LatLng(
          parseFloat(markerNodesB[i].getAttribute("lat")),
          parseFloat(markerNodesB[i].getAttribute("lng"))
        );

        this.createMarkerB(
          latlng,
          name,
          address,
          city,
          province,
          postalCode,
          phone,
          storeId
        );
        boundsB.extend(latlng);
      }

      mapB.fitBounds(boundsB);
    }
  };

  createMarker = (
    latlng,
    name,
    address,
    city,
    province,
    postalCode,
    phone,
    storeId
  ) => {
    const marker = new window.google.maps.Marker({
      map: map,
      label: labels[labelIndex++ % labels.length],
      position: latlng
    });
    window.google.maps.event.addListener(marker, "click", function() {
      window.targetStore(storeId);
    });
    markers.push(marker);
  };

  createMarkerB = (
    latlng,
    name,
    address,
    city,
    province,
    postalCode,
    phone,
    storeId
  ) => {
    const markerB = new window.google.maps.Marker({
      map: mapB,
      label: labels[labelIndex++ % labels.length],
      position: latlng
    });
    window.google.maps.event.addListener(markerB, "click", function() {
      window.targetStore(storeId);
    });
    markers.push(markerB);
  };

  createResultsList = (
    storeId,
    name,
    address,
    phone,
    city,
    province,
    postalCode
  ) => {
    let listHTML = `<li class="ResultList-item ResultList-item--ordered js-location-result" id="store-id${storeId}">`;
    listHTML += '<article class="Teaser Teaser--ace Teaser--long">';
    listHTML += `<h3 class="Teaser-title"><span class="LocationName" itemprop="name" id="location-name"><span class="LocationName-brand">${name}</span></span></h3>`;
    listHTML += `<div class="Teaser-address"><address class="c-address" data-country="CA"><div class="c-AddressRow"><span class="c-address-street-1">${address}</span> </div><div class="c-AddressRow"><span class="c-address-city">${city}</span><yxt-comma>,</yxt-comma> </span><abbr class="c-address-state">${province}</abbr> <span class="c-address-postal-code">${postalCode}</span> </div><div class="c-AddressRow"> </div></address></div>`;
    listHTML += '<div class="Teaser-phone">';
    listHTML += '<div class="c-phone c-phone-MAIN">';
    listHTML +=
      '<div class="c-phone-label c-phone-MAIN-label"><span class="sr-only">phone</span></div>';
    listHTML +=
      '<div class="c-phone-number-wrapper c-phone-MAIN-number-wrapper">';
    listHTML += `<div class="c-phone-number c-phone-MAIN-number"><a class="c-phone-number-link c-phone-MAIN-number-link" href="tel:${phone}" data-ya-track="phone">${phone}</a><span class="c-phone-number-span c-phone-MAIN-number-span">${phone}</span></div>`;
    listHTML += "</div>";
    listHTML += "</div>";
    listHTML += "</div>";
    listHTML += '<div class="Teaser-linksRow">';
    listHTML += '<div class="Teaser-links">';
    listHTML += '<div class="Teaser-link Teaser-directions">';
    listHTML += '<div class="c-get-directions">';
    listHTML += `<div class="c-get-directions-button-wrapper"><a class="c-get-directions-button" href="https://www.google.ca/maps?daddr=${address},${city},${province},${postalCode},CA&hl=en" target="_blank" rel="nofollow noopener noreferrer" data-ga-category="Get Directions" data-ya-track="directions" >Get Directions</a></div>`;
    listHTML += "</div>";
    listHTML += "</div>";
    listHTML += "</div>";
    listHTML += "</div>";
    listHTML += "</article>";
    listHTML += "</li>";

    resultList.innerHTML += listHTML;
  };

  searchLocationsNear = center => {
    this.clearLocations();

    const radius = window.document.getElementById("radiusSelect").value;
    let psearchUrl = "/storefinder/";

    const params = {
      lat: center.lat(),
      lng: center.lng(),
      radius
    };

    c_lat = params.lat;
    c_lng = params.lng;

    if (localenv === true) {
      psearchUrl = "http://localhost:8000/localstores/";
      this.localdownloadUrl(psearchUrl, params);
    } else {
      this.downloadUrl(psearchUrl, params);
    }
  };

  searchLocations = () => {
    this.clearLocations();
    labelIndex = 0;
    address = window.document.getElementById("addressInput").value;
    const geocoder = new window.google.maps.Geocoder();
    resultsummary.innerHTML = "";

    resultList.innerHTML = "";

    // searchLocationsNear
    geocoder.geocode(
      {
        address
      },
      function(results, status) {
        if (status === window.google.maps.GeocoderStatus.OK) {
          window.searchLocationsNear(results[0].geometry.location);
        } else {
          if (userlang === "en") {
            window.document.getElementById("msg").innerHTML =
              "You must enter an address to see results";
          } else {
            window.document.getElementById("msg").innerHTML =
              "Vous devez entrer une adresse pour voir les résultats";
          }
        }
      }
    );
  };

  clearLocations = () => {
    for (let i = 0; i < markers.length; i++) {
      markers[i].setMap(null);
    }
    markers.length = 0;
  };

  downloadUrl = (url, data) => {
    let sendheaders = {};
    if (!csrfSafeMethod("POST") && sameOrigin(url)) {
      //console.log(`pass test + csrftoken: ${csrftoken}`);
      sendheaders = {
        "X-CSRFToken": csrftoken,
        "Content-type": "application/json"
      };
    } else {
      sendheaders = {};
    }

    axios
      .post(
        url,
        {
          params: data
        },
        { headers: sendheaders }
      )
      .then(res => this.buildMaps(res.data, data))
      .catch(err => {
        if (String.prototype.trim.call(String(err.status)) === "undefined")
          doNothing();
        else console.log("AXIOS ERROR: ", err.status);
      });
  };

  localdownloadUrl = (url, data) => {
    const postheaders = {
      "Content-type": "application/json",
      "X-CSRFToken": csrftoken
      /* 'Access-Control-Allow-Origin': '*', */
    };

    axios
      .post(
        url,
        {
          params: data
        },
        { headers: postheaders }
      )
      .then(res => this.buildMaps(res.data, data))
      .catch(err => {
        if (String.prototype.trim.call(String(err.status)) === "undefined")
          doNothing();
        //else console.log('AXIOS ERROR: ', err.status);
      });
  };

  getCityState = (lat, long, rcount) => {
    const detailsUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${long}&key=${googleMapsApiKey}&sensor=false`;
    axios
      .get(detailsUrl)
      .then(res => this.updateAddress(res.data, rcount))
      .catch(err => {
        //console.log(err);
      });
  };

  updateAddress = (userloc, rcount) => {
    const data = userloc.results[0].address_components;

    if (data.length !== 0) {
      for (const key in data) {
        if (data[key].types[0] === "locality") {
          city = data[key].short_name;
        }

        if (data[key].types[0] === "administrative_area_level_1") {
          province = data[key].short_name;
        }

        if (data[key].types[0] === "country") {
          country = data[key].short_name;
        }

        if (data[key].types[0] === "postal_code") {
          postal_code = data[key].short_name;
        }
      }
    }

    if (userAgree === true) {
      usersearchLocation = `${city}, ${province}, ${country}, ${postal_code}`;
    } else {
      usersearchLocation = `${city}, ${province}, ${country}`;
    }

    window.document.getElementById("addressInput").value = usersearchLocation;
    window.history.pushState("", "", "?addr=" + usersearchLocation);
    searchTarget = usersearchLocation;
    window.document.getElementById("locator-results-row").style.display =
      "block";
    if (userlang === "en") {
      window.document.getElementById(
        "summary"
      ).innerHTML = `${rcount} locations near "<span class="ResultSummary-query">${searchTarget}</span>"`;
    } else {
      window.document.getElementById(
        "summary"
      ).innerHTML = `${rcount} sites près de "<span class="ResultSummary-query">${searchTarget}</span>"`;
    }
    window.document.getElementById("summary").style.visibility = "visible";
  };

  targetStore = id => {
    //console.log(`Target Store: ${id}`);
    this.checkSelect();
    const elmnt = window.document.getElementById(`store-id${id}`);
    elmnt.classList.add("active");
    elmnt.scrollIntoView();
  };

  checkSelect = () => {
    const results = window.document.querySelectorAll(".Locator-results ol li");
    for (let i = 0; i < results.length; i++) {
      results[i].classList.remove("active");
      results[i].onclick = function(event) {
        //console.log('ONCLICK');
        // remove all active class
        //this.removeClass(results[i]);
        if (event.target.innerHTML === this.innerHTML) {
          this.classList.add("active");
        }
      };
    }
  };

  removeClass = results => {
    for (let i = 0; i < results.length; i++) {
      results[i].classList.remove("active");
    }
  };

  render() {
    return (
      <React.Fragment>
        <input type="hidden" id="startLat" name="startLat" />
        <input type="hidden" id="startLon" name="startLon" />
        <div id="map" className="map">
          Store Locations Map
        </div>
      </React.Fragment>
    );
  }
}

function loadScript(url) {
  //console.log(url);
  const index = window.document.getElementsByTagName("script")[0];
  const script = window.document.createElement("script");
  script.src = url;
  script.async = true;
  script.defer = true;
  index.parentNode.insertBefore(script, index); // similar to appendChild. inserts script at the beginning of all script tags
}

function csrfSafeMethod(method) {
  // these HTTP methods do not require CSRF protection
  return /^(GET|HEAD|OPTIONS|TRACE)$/.test(method);
}

function sameOrigin(url) {
  // test that a given url is a same-origin URL
  // url could be relative or scheme relative or absolute
  const host = document.location.host; // host + port
  const protocol = document.location.protocol;
  const sr_origin = `//${host}`;
  const origin = protocol + sr_origin;
  // Allow absolute or scheme relative URLs to same origin
  return (
    url === origin ||
    url.slice(0, origin.length + 1) === `${origin}/` ||
    url === sr_origin ||
    url.slice(0, sr_origin.length + 1) === `${sr_origin}/` ||
    // or any other URL that isn't scheme relative or absolute i.e relative.
    !/^(\/\/|http:|https:).*/.test(url)
  );
}

const searchLocationsNear = (center: any) => {
  this.clearLocations();

  const radiusSelect: any = window.document.getElementById("radiusSelect");
  const radius = radiusSelect.value;
  let psearchUrl = "/storefinder/";

  const params: any = {
    lat: center.lat(),
    lng: center.lng(),
    radius
  };

  if (localenv === true) {
    psearchUrl = "http://localhost:8000/localstores/";
    this.localdownloadUrl(psearchUrl, params);
  } else {
    this.downloadUrl(psearchUrl, params);
  }
};

function doNothing() {}

export default Storelocator;
